<template>
  <p id="tabel-dinamis-title" class="w-100 text-center font-weight-bold">
    <span class="td-text-blue">Tabel </span>
    <span class="td-text-grey">Dinamis</span>
    <span class="ml-2" style="font-size: 0.7rem">Ver. <slot></slot></span>
  </p>
</template>

<!-- javascript section-->
<script>
//import js modules section

//local registration for output component
export default {
  name: "Title",
  data() {
    return {};
  },
  props: [],
  created() {},
  destroyed() {},
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
#tabel-dinamis-title {
  font-size: 2.5rem;

  span:not(:last-child) {
    letter-spacing: 0.05em;
    text-shadow: 2px 2px 0px #d5d5d5, 4px 4px 0px rgba(0, 0, 0, 0.2);
  }
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 19-04-2022 -->
